import React, { useState, useEffect } from "react";
import { Popover, Box, TextField, Button, Typography } from "@material-ui/core";
import Select from "react-select";
import { useCreateJobProfile } from "../../hooks/useCreateJobProfile";
import { useUpdateJobProfile } from "../../hooks/useUpdateJobProfile";
import Swal from "sweetalert2";

const ProfessionalQualificationModal = ({
  open,
  onClose,
  isUpdate,
  item,
  regionOptions,
  defaultRegion,
}) => {
  const [name, setName] = useState("");
  const [selectedRegion, setSelectedRegion] = useState(null);

  const createMutation = useCreateJobProfile();
  const updateMutation = useUpdateJobProfile();

  useEffect(() => {
    if (isUpdate && item) {
      setName(item.name || "");
      const regionMatch = regionOptions.find(
        (r) => r.value === (item.regionId || item.region)
      );
      setSelectedRegion(regionMatch || defaultRegion);
    } else {
      setName("");
      setSelectedRegion(defaultRegion || null);
    }
  }, [isUpdate, item, open]);

  const isFormValid = name.trim() !== "" && selectedRegion !== null;

  const handleSave = () => {
    const payload = { name: name.trim(), regionId: selectedRegion.value };

    if (isUpdate) {
      updateMutation.mutate(
        { id: item.key || item._id, input: payload },
        {
          onSuccess: () => {
            onClose();
            Swal.fire({
              icon: "success",
              title: "Professional Qualification updated!",
              showConfirmButton: false,
              timer: 1500,
            });
          },
          onError: (error) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: error?.response?.data?.message || error.message,
              showConfirmButton: true,
            });
          },
        }
      );
    } else {
      createMutation.mutate(
        { input: payload },
        {
          onSuccess: () => {
            onClose();
            Swal.fire({
              icon: "success",
              title: "Professional Qualification created!",
              showConfirmButton: false,
              timer: 1500,
            });
          },
          onError: (error) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: error?.response?.data?.message || error.message,
              showConfirmButton: true,
            });
          },
        }
      );
    }
  };

  return (
    <Popover
      open={open}
      onClose={onClose}
      anchorReference="none"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
      PaperProps={{
        style: {
          padding: "24px",
          maxWidth: "750px",
          width: "100%",
          margin: "auto",
          overflow: "visible",
        },
      }}
    >
      <Box>
        <Typography variant="h6" gutterBottom>
          {isUpdate ? "Update Professional Qualification" : "New Professional Qualification"}
        </Typography>

        <TextField
          required
          label="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          margin="normal"
        />

        <Box style={{ marginTop: "8px", marginBottom: "16px" }}>
          <Typography variant="body2" style={{ marginBottom: "4px" }}>
            Region *
          </Typography>
          <Select
            value={selectedRegion}
            onChange={(value) => setSelectedRegion(value)}
            options={regionOptions}
            isClearable
            placeholder="Select Region"
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          />
        </Box>

        <Box style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            disabled={
              !isFormValid ||
              createMutation.isLoading ||
              updateMutation.isLoading
            }
          >
            {isUpdate ? "Update" : "Save"}
          </Button>
        </Box>
      </Box>
    </Popover>
  );
};

export default ProfessionalQualificationModal;
